import {
  CANVA_BASE_URL,
  CANVA_USER_SCOPES,
  canva_endpoints,
} from '../../../utils/constants/canva';

import { encrypted } from '../../../utils/utility';

import CryptoJS from 'crypto-js';

// Function to generate a random string of specified length
function generateRandomString(length: number) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return array;
}

// Function to convert a byte array to a base64url encoded string
function toBase64Url(bytes: Uint8Array | number[]) {
  return btoa(
    String.fromCharCode.apply(null, bytes as number[])
  )
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

// Generate codeVerifier
const codeVerifierBytes = generateRandomString(96);
const codeVerifier = toBase64Url(codeVerifierBytes);

// Generate codeChallenge
const codeChallenge = CryptoJS.SHA256(codeVerifier)
  .toString(CryptoJS.enc.Base64)
  .replace(/\+/g, '-')
  .replace(/\//g, '_')
  .replace(/=+$/, '');

export const openCanvaAuthWindow = () => {
  const encryptedVerifier = encrypted.encrypt(codeVerifier);
  localStorage.setItem('codeVerifier', encryptedVerifier);
  const scopeString = CANVA_USER_SCOPES.join(' ');
  const clientId = process.env.REACT_APP_CANVA_CLIENT_ID;

  const url = new URL(
    `${CANVA_BASE_URL}${canva_endpoints.AUTHORIZE}`
  );
  url.searchParams.append('code_challenge', codeChallenge);
  url.searchParams.append('code_challenge_method', 'S256');
  url.searchParams.append('scope', scopeString);
  url.searchParams.append('response_type', 'code');
  url.searchParams.append(
    'redirect_uri',
    `${window.location.origin}${canva_endpoints.REDIRECT}`
  );

  if (clientId) {
    url.searchParams.append('client_id', clientId);
  } else {
    return {
      error: 'client_id not found',
    };
  }

  window.open(url.toString());
};
